import { useRef } from 'react'
import { preventBubbling } from './stop-propagation'

export function useClickOnRef() {
    const ref = useRef(null)

    const onClicked = preventBubbling(() => {
        if (ref.current) {
            ref.current.click()
        }
    })

    return [ref, onClicked]
}
